"use client";

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes";

export const ThemeProvider = ({ children, ...props }: ThemeProviderProps) => {
    return <NextThemesProvider { ...props }>{children}</NextThemesProvider>;
};